<template>
    <form-dialog title="新增手术信息" width="80%" :visible.sync="visibleSync" :data="{}" :columns="columnList" @confirm="postOne" :buttons="editButtons"></form-dialog>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `AddSurgery`,
    props: {
        visible: { type: Boolean },
        isEmergency: { type: Number, default: 0 },
        defaultplanTime: { type: String }
    },
    data() {
        return {
            title: `新增手术申请`,
            isWorkerByDuty: this.$root.IsWorkerByDuty,
            CalendarScheduleOpenPatientInfoQuery: this.$root.CalendarScheduleOpenPatientInfoQuery,
            isAutoCalculatePlanTime: this.$root.IsAutoCalculatePlanTime,
            editButtons: [{
                label: `确认排程`,
                type: `default`,
                permission: `ApplySurgery:ConfirmSchedule`
            }],
            o_dic_operating_ward_id: undefined,
            checkCutLevel: this.$root.CheckCutLevel || `0`
        }
    },
    created() {
    },
    computed: {
        ...mapGetters([
            `surgery/visit_type`,
            `surgery/anaesthesia_method`,
            `operation_room_auth`,
            `section_auth`,
            `inpatient_section_auth`,
            `operation_ward_auth`,
            `sys_enums`,
            `sysuser/workers_by_duty`,
            `permissions`,
            `sysuser/workers_by_dutyNew`,
            `active_ward`,
            `otherSettingColumn`,
            `extendColumnList`
        ]),
        dic_operating_ward_id: {
            get: function() {
                if (this.active_ward && _.startsWith(this.active_ward.value, `ow_`)) {
                    this.o_dic_operating_ward_id = this.active_ward.origion
                }
                return this.o_dic_operating_ward_id
            },
            set: function(v) {
                this.o_dic_operating_ward_id = v
                this.issetoperatingward = true
            }
        },
        worker() {
            if (this.isWorkerByDuty == `0`) {
                return this[`sysuser/workers_by_duty`]
            } else if (this.isWorkerByDuty == `1`) {
                return this[`sysuser/workers_by_dutyNew`]
            }
        },
        columnList() {
            let me = this
            // 显示新增列
            let createC = [
                {
                    type: `p`,
                    prop: `title1`,
                    isCreatable: true,
                    isEditable: true,
                    placeholder: `　患者信息`,
                    label: { content: ` `, position: `top` }
                },
                {
                    type: `p`,
                    prop: `title1`,
                    isCreatable: true,
                    isEditable: true,
                    placeholder: `　手术信息`,
                    label: { content: ` `, position: `top` }
                },
                {
                    type: `select`,
                    prop: `enum_visit_type`,
                    label: `就诊类型`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6,
                    default: 1,
                    options: this.sys_enums.VisitType || [],
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `string1`,
                    prop: `visit_no`,
                    label: this.T(`apply_surgery.visit_no`),
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6,
                    blurchange: (that, { changetext, changeid, index, row, prop, column }) => {
                        if (this.CalendarScheduleOpenPatientInfoQuery === `true`) {
                            if (row.visit_no && row.visit_no != ``) {
                                console.log(row.visit_no)
                                let req = this.myaxios.post(`/api/Preoperative/Apply/GetByVisitNo?visitNo=${row.visit_no}&visitType=${row.enum_visit_type}&dic_operating_ward_id=${row.dic_operating_ward_id}`)
                                req.then(data => {
                                    console.log(data)
                                    if (data) {
                                        if (data === `error`) {
                                            this.$message.error(`调用kettle获取患者信息失败！详情查阅日志！`)
                                        } else {
                                            let info = JSON.parse(data)
                                            _.each(row, (value, key) => {
                                                row[key] = info[key]
                                            })
                                        }
                                    }
                                })
                            }
                        }
                    },
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `remotemultiselect`,
                    prop: `plan_surgeries`,
                    label: `拟施手术`,
                    showCount: 3,
                    collapseTags: false,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 12,
                    options: `/api/AcisSystem/Surgery/SearchIncludOpeLevel`,
                    // validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    change: (that, { row }) => {
                        if (_.isEmpty(row.plan_surgeries)) {
                            row.enum_surgery_scale = undefined
                        } else {
                            var max = -1
                            for (let item of row.plan_surgeries) {
                                try {
                                    if (item.description) {
                                        let level = parseInt(item.description)
                                        if (level > max) { max = level }
                                    }
                                } catch (err) {
                                    console.log(err)
                                }
                            }
                            if (max > 0) {
                                row.enum_surgery_scale = max
                            } else {
                                row.enum_surgery_scale = undefined
                            }
                        }
                    }
                },
                {
                    type: `string`,
                    prop: `name`,
                    label: `姓名`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `datetime`,
                    prop: `visit_time`,
                    label: `入院时间`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6
                },
                {
                    type: `select`,
                    prop: `is_day_surgery`,
                    label: `日间手术`,
                    width: `80`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6,
                    options: `enum_bool`
                },
                {
                    type: `select`,
                    prop: `enum_outoperatingroomtype`,
                    label: `室外麻醉分类`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.sys_enums.Enum_OutOperatingRoomType || [],
                    colspan: 6
                },
                {
                    type: `string`,
                    prop: `outpatient_no`,
                    label: `门诊号`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6
                },
                {
                    type: `string`,
                    prop: `his_id`,
                    label: `病案号`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6
                },
                {
                    type: `remotemultiselect`,
                    prop: `plan_diseases`,
                    label: `术前诊断`,
                    showCount: 3,
                    collapseTags: false,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 12,
                    options: `/api/AcisSystem/Disease/Search`
                    // validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `select`,
                    prop: `enum_sex`,
                    label: `性别`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6,
                    options: this.sys_enums.Enum_Sex || []
                },
                {
                    type: `string`,
                    prop: `bed_no`,
                    label: `床号`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6
                }, {
                    type: `select`,
                    prop: `dic_operating_ward_id`,
                    label: `手术区`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.operation_ward_auth || [],
                    colspan: 6,
                    default: this.dic_operating_ward_id,
                    validate: [{ required: true, message: `必填项目`, trigger: `change` }],
                    change: (that, { row }) => {
                        row.dic_operating_room_id = undefined
                    }
                },
                {
                    type: `select`,
                    prop: `dic_operating_room_id`,
                    label: `手术间`,
                    isCreatable: true,
                    isEditable: true,
                    options: (that, { row }) => {
                        let r = _.filter(this[`operation_ward_auth`], { value: row.dic_operating_ward_id })
                        return (r && r[0] && r[0].operation_room) || []
                    },
                    change: (that, { row }) => {
                        if (this.isAutoCalculatePlanTime === `true`) {
                            if (row.dic_operating_room_id) {
                                let req = this.myaxios.get(`/api/Preoperative/Apply/GetPlanTimeByRoomId?roomId=${row.dic_operating_room_id}&planDate=${row.plan_time}`)
                                req.then(data => {
                                    this.$set(row, `plan_time`, data)
                                })
                            }
                        }
                    },
                    colspan: 6
                },
                {
                    type: `remoteselect`,
                    prop: `sectionobj`,
                    label: `科室`,
                    isCreatable: true,
                    isEditable: true,
                    options: (that, { row }) => {
                        return q => {
                            let sections = _.cloneDeep(this[`section_auth`])
                            console.log(`sections`, sections)
                            if (q && q.keyword) {
                                let f = sections.filter(d => {
                                    return d.code.indexOf(q.keyword) > -1 || d.label.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                                console.log(`f`, f)
                                return f
                            } else {
                                console.log(`search`, sections)
                                return sections
                            }
                        }
                    },
                    colspan: 6,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `remoteselect`,
                    prop: `inpatientobj`,
                    label: `病区`,
                    isCreatable: true,
                    isEditable: true,
                    // options:this["section_auth"],
                    options: (that, { row }) => {
                        return q => {
                            let sections = _.cloneDeep(this[`inpatient_section_auth`])
                            console.log(`sections`, sections)
                            if (q && q.keyword) {
                                let f = sections.filter(d => {
                                    return d.code.indexOf(q.keyword) > -1 || d.label.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                                console.log(`f`, f)
                                return f
                            } else {
                                console.log(`search`, sections)
                                return sections
                            }
                        }
                    },
                    colspan: 6,
                    default: this.dic_section_surgery
                },

                {
                    type: `datetime`,
                    prop: `plan_time`,
                    label: `手术时间`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6,
                    default: this.defaultplanTime,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `float`,
                    prop: `cost_time`,
                    label: `预计时长`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6
                },
                {

                    // type: this.$root.UseSurgeryScaleCheck == `1` ? `select_manyCos` : `select`,
                    type: `remoteselect`,
                    prop: `plan_surgeon`,
                    label: this.T(`apply_surgery.plan_surgeon`),
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6,
                    // options: this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`手术医生`] || [],
                    options: (that, { row }) => {
                        return q => {
                            let works = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`手术医生`] || []
                            let worksarr = _.cloneDeep(works)
                            if (me.scheduleWorkerFilter == `1`) {
                                worksarr = _.filter(worksarr, function(i) {
                                    return !me.surgeryInfo.dic_hospital_ward_id || _.includes(i.hospital_wardids, me.surgeryInfo.dic_hospital_ward_id)
                                })
                            } else if (me.scheduleWorkerFilter == `2`) {
                                worksarr = _.filter(worksarr, function(i) {
                                    return !me.surgeryInfo.dic_operating_ward_id || _.includes(i.wardids, me.surgeryInfo.dic_operating_ward_id)
                                })
                            }
                            if (this.$root.UseSurgeryScaleCheck == `1`) {
                                worksarr = worksarr.map(d => {
                                    return {
                                        label: d.label,
                                        value: d.value,
                                        jianpin: d.jianpin,
                                        card_no: d.card_no,
                                        worker_duty: d.worker_duty,
                                        //  code: d.code,
                                        // worker_duty:d.worker_duty=="麻醉助手"?"麻醉医生":(d.worker_duty=="手术助手"?"手术医生":(d.worker_duty=="器械护士"?"巡回护士":d.worker_duty)),
                                        code: d.surgery_scale == null ? `--/${d.code}` : d.surgery_scale + `/` + d.code
                                    }
                                })
                            }

                            if (q && q.keyword) {
                                return worksarr.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return worksarr
                            }
                        }
                    }
                    // validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    // type: this.$root.UseSurgeryScaleCheck == `1` ? `select_manyCos_multiselect` : `multiselect`,
                    type: `remotemultiselect`,
                    prop: `plan_surgeon_assistants`,
                    label: this.T(`apply_surgery.plan_surgeon_assistants`),
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6,
                    // options: this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`手术医生`] || [],
                    options: (that, { row }) => {
                        return q => {
                            let works = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`手术医生`] || []
                            let worksarr = _.cloneDeep(works)
                            if (me.scheduleWorkerFilter == `1`) {
                                worksarr = _.filter(worksarr, function(i) {
                                    return !me.surgeryInfo.dic_hospital_ward_id || _.includes(i.hospital_wardids, me.surgeryInfo.dic_hospital_ward_id)
                                })
                            } else if (me.scheduleWorkerFilter == `2`) {
                                worksarr = _.filter(worksarr, function(i) {
                                    return !me.surgeryInfo.dic_operating_ward_id || _.includes(i.wardids, me.surgeryInfo.dic_operating_ward_id)
                                })
                            }
                            if (this.$root.UseSurgeryScaleCheck == `1`) {
                                worksarr = worksarr.map(d => {
                                    return {
                                        label: d.label,
                                        value: d.value,
                                        jianpin: d.jianpin,
                                        card_no: d.card_no,
                                        worker_duty: d.worker_duty,
                                        //  code: d.code,
                                        // worker_duty:d.worker_duty=="麻醉助手"?"麻醉医生":(d.worker_duty=="手术助手"?"手术医生":(d.worker_duty=="器械护士"?"巡回护士":d.worker_duty)),
                                        code: d.surgery_scale == null ? `--/${d.code}` : d.surgery_scale + `/` + d.code
                                    }
                                })
                            }
                            if (q && q.keyword) {
                                return worksarr.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return worksarr
                            }
                        }
                    }
                },
                {
                    type: `date`,
                    prop: `birthday`,
                    label: `出生日期`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6,
                    change: (that, { row }) => {
                        let bir = row.birthday
                        let currentDate = this.$moment()
                        let birthDate = this.$moment(bir || ``)
                        let age = this.$moment.duration(currentDate.diff(birthDate))._data
                        row.age = age.years == 0 ? (age.months == 0 ? `${age.days}天` : `${age.months}月`) : `${age.years}岁`
                    }
                },
                {
                    type: `string`,
                    prop: `age`,
                    label: `年龄`,
                    isCreatable: true,
                    isEditable: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `change` }],
                    colspan: 6
                },
                {
                    type: `select`,
                    prop: `enum_surgery_type`,
                    label: `手术类型`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.sys_enums.Enum_SurgeryType || [],
                    readonly: this.isEmergency == 1,
                    colspan: 6,
                    default: 1
                },
                {
                    type: `select`,
                    prop: `enum_isolation_status`,
                    label: `隔离状态`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.sys_enums.IsolationStatus || [],
                    colspan: 6
                },
                {
                    type: `select`,
                    prop: `card_type`,
                    label: `证件类型`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6,
                    options: this.sys_enums.Enum_CardType || []
                },
                {
                    type: `string`,
                    prop: `card_no`,
                    label: `证件号`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6
                },
                {
                    type: `select`,
                    prop: `enum_surgery_scale`,
                    label: `手术分级`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.sys_enums.Enum_SurgeryScale || [],
                    colspan: 6
                },
                {
                    type: `select`,
                    prop: `enum_cut_level`,
                    label: `切口分类`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.sys_enums.Enum_CutLevel || [],
                    colspan: 6,
                    change: (that, { row }) => {
                        if (me.checkCutLevel && me.checkCutLevel == `1` && row.enum_cut_level == 1) {
                            me.$alert(`<strong>请确认是否I类手术切口</strong>`, `提示`, {
                                dangerouslyUseHTMLString: true,
                                type: `warning`
                            })
                        }
                    }
                },
                {
                    type: `string`,
                    prop: `address`,
                    label: `地址`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 12
                },
                {
                    type: `select`,
                    prop: `is_endoscopy`,
                    label: `内镜检查`,
                    width: `80`,
                    isCreatable: true,
                    isEditable: true,
                    options: `enum_bool`,
                    colspan: 6
                },
                {
                    type: `string`,
                    prop: `phone`,
                    label: `电话`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6
                },
                {
                    type: `multiselect`,
                    prop: `plan_anaes_methods`,
                    label: `麻醉方式`,
                    showCount: 3,
                    collapseTags: false,
                    isCreatable: true,
                    isEditable: true,
                    options: (that, { row }) => {
                        return _.filter(this[`surgery/anaesthesia_method`], function(i) { return (i.enum_dic_type === 1 || i.enum_dic_type === 2) })
                    },

                    colspan: 12
                },
                {
                    type: `select`,
                    prop: `enum_pay_type`,
                    label: `费用类别`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.sys_enums.Enum_PayType || [],
                    colspan: 6
                },
                {
                    type: `string`,
                    prop: `insurance_no`,
                    label: `社保卡号`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6
                },
                {
                    type: `remoteselect`,
                    prop: `plan_anes_doctor`,
                    label: this.T(`apply_surgery.plan_anes_doctor`),
                    isCreatable: true,
                    isEditable: true,
                    // options: this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`麻醉医生`] || [],
                    options: (that, { row }) => {
                        return q => {
                            let works = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`麻醉医生`] || []
                            let worksarr = _.cloneDeep(works)
                            if (me.scheduleWorkerFilter == `1`) {
                                worksarr = _.filter(worksarr, function(i) {
                                    return !me.surgeryInfo.dic_hospital_ward_id || _.includes(i.hospital_wardids, me.surgeryInfo.dic_hospital_ward_id)
                                })
                            } else if (me.scheduleWorkerFilter == `2`) {
                                worksarr = _.filter(worksarr, function(i) {
                                    return !me.surgeryInfo.dic_operating_ward_id || _.includes(i.wardids, me.surgeryInfo.dic_operating_ward_id)
                                })
                            }
                            if (this.$root.UseASACheck == `1`) {
                                worksarr = worksarr.map(d => {
                                    return {
                                        label: d.label,
                                        value: d.value,
                                        jianpin: d.jianpin,
                                        card_no: d.card_no,
                                        worker_duty: d.worker_duty,
                                        //  code: d.code,
                                        // worker_duty:d.worker_duty=="麻醉助手"?"麻醉医生":(d.worker_duty=="手术助手"?"手术医生":(d.worker_duty=="器械护士"?"巡回护士":d.worker_duty)),
                                        code: d.asa == null ? `--/${d.code}` : d.asa + `/` + d.code

                                    }
                                })
                            }
                            if (q && q.keyword) {
                                return worksarr.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return worksarr
                            }
                        }
                    },
                    colspan: 6
                },

                {
                    type: `remotemultiselect`,
                    prop: `plan_anes_assistants`,
                    label: this.T(`apply_surgery.plan_anes_assistants`),
                    isCreatable: true,
                    isEditable: true,
                    options: (that, { row }) => { // added by xiaorui,ACIS-23399  排程界面的麻醉助手权限改动：既可以选择医生，又可选择护士
                        return q => {
                            let works = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`麻醉医生`] || []
                            let deepworkers = JSON.parse(JSON.stringify(works))
                            let hsworkers = this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || []
                            hsworkers.forEach((item, index) => {
                                let mc = _.find(deepworkers, x => x.value == item.value)
                                if (mc) {
                                } else {
                                    deepworkers.push(item)
                                }
                            })
                            if (this.$root.UseASACheck == `1`) {
                                console.log(`过滤等级`)
                                deepworkers = deepworkers.map(d => {
                                    return {
                                        label: d.label,
                                        value: d.value,
                                        jianpin: d.jianpin,
                                        card_no: d.card_no,
                                        worker_duty: d.worker_duty,
                                        //  code: d.code,
                                        // worker_duty:d.worker_duty=="麻醉助手"?"麻醉医生":(d.worker_duty=="手术助手"?"手术医生":(d.worker_duty=="器械护士"?"巡回护士":d.worker_duty)),
                                        code: d.asa == null ? `--/${d.code}` : d.asa + `/` + d.code

                                    }
                                })
                            }
                            let worksarr = _.cloneDeep(deepworkers)
                            if (me.scheduleWorkerFilter == `1`) {
                                worksarr = _.filter(worksarr, function(i) {
                                    return !me.surgeryInfo.dic_hospital_ward_id || _.includes(i.hospital_wardids, me.surgeryInfo.dic_hospital_ward_id)
                                })
                            } else if (me.scheduleWorkerFilter == `2`) {
                                worksarr = _.filter(worksarr, function(i) {
                                    return !me.surgeryInfo.dic_operating_ward_id || _.includes(i.wardids, me.surgeryInfo.dic_operating_ward_id)
                                })
                            }

                            if (q && q.keyword) {
                                return worksarr.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return worksarr
                            }
                        }
                    },
                    colspan: 6
                },
                {
                    type: `select`,
                    prop: `enum_blood_type`,
                    label: `血型`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.sys_enums.Enum_BloodType || [],
                    colspan: 6
                },
                {
                    type: `select`,
                    prop: `enum_rh_blood_type`,
                    label: `RH`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.sys_enums.Enum_RhBloodType || [],
                    colspan: 6
                },
                {
                    type: `remotemultiselect`,
                    prop: `plan_circuit_nurse`,
                    label: this.T(`apply_surgery.plan_circuit_nurse`),
                    isCreatable: true,
                    isEditable: true,
                    options: (that, { row }) => {
                        return q => {
                            let works = this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || []
                            let worksarr = _.cloneDeep(works)
                            if (me.scheduleWorkerFilter == `1`) {
                                worksarr = _.filter(worksarr, function(i) {
                                    return !me.surgeryInfo.dic_hospital_ward_id || _.includes(i.hospital_wardids, me.surgeryInfo.dic_hospital_ward_id)
                                })
                            } else if (me.scheduleWorkerFilter == `2`) {
                                worksarr = _.filter(worksarr, function(i) {
                                    return !me.surgeryInfo.dic_operating_ward_id || _.includes(i.wardids, me.surgeryInfo.dic_operating_ward_id)
                                })
                            }
                            if (q && q.keyword) {
                                return worksarr.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return worksarr
                            }
                        }
                    },
                    colspan: 6
                },
                {
                    type: `remotemultiselect`,
                    prop: `plan_equipment_nurse`,
                    label: this.T(`apply_surgery.plan_equipment_nurse`),
                    isCreatable: true,
                    isEditable: true,
                    options: (that, { row }) => {
                        return q => {
                            let works = this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || []
                            let worksarr = _.cloneDeep(works)
                            if (me.scheduleWorkerFilter == `1`) {
                                worksarr = _.filter(worksarr, function(i) {
                                    return !me.surgeryInfo.dic_hospital_ward_id || _.includes(i.hospital_wardids, me.surgeryInfo.dic_hospital_ward_id)
                                })
                            } else if (me.scheduleWorkerFilter == `2`) {
                                worksarr = _.filter(worksarr, function(i) {
                                    return !me.surgeryInfo.dic_operating_ward_id || _.includes(i.wardids, me.surgeryInfo.dic_operating_ward_id)
                                })
                            }
                            if (q && q.keyword) {
                                return worksarr.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return worksarr
                            }
                        }
                    },
                    colspan: 6
                },
                {
                    type: `string`,
                    prop: `height`,
                    label: `身高(cm)`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6
                },
                {
                    type: `string`,
                    prop: `weight`,
                    label: `体重(kg)`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6
                },
                {
                    type: `select`,
                    prop: `enum_asa`,
                    label: `ASA`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.sys_enums.Enum_ASA || [],
                    colspan: 6
                },
                {
                    type: `string`,
                    prop: `his_remark`,
                    label: `申请备注`,
                    isCreatable: false,
                    isEditable: true,
                    readonly: true,
                    colspan: 18
                },
                {
                    type: `string`,
                    prop: `remark`,
                    label: `备注`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 12
                },
                {
                    type: `multiselect`,
                    prop: `infectious`,
                    label: this.T(`apply_surgery.infectious`),
                    isCreatable: true,
                    isEditable: true,
                    // options: `enum_infectious`,
                    options: (that, { row }) => {
                        let data = this.sys_enums.Enum_Infectious || []
                        var ret = data.map(d => {
                            d.value = d.label
                            return d
                        })
                        return ret
                    },
                    colspan: 6
                },
                {
                    type: `select`,
                    prop: `is_fasting`,
                    label: `术前禁食`,
                    isCreatable: true,
                    isEditable: true,
                    options: `enum_bool`,
                    colspan: 6
                }
            ]
            // 显示动态扩展列
            createC = this.$surgeryInfoExtraParamUtil.SetExtraColumnList(this.extendColumnList, createC)
            createC = _.filter(createC, function(d) {
                return d.isCreatable === true
            })
            return createC
        },
        visibleSync: {
            get: function() {
                return this.visible
            },
            set: function(newval) {
                this.$emit(`update:visible`, newval)
            }
        }
    },
    methods: {
        postOne(data) {
            let that = this
            return new Promise((resolve, reject) => {
                if (data.isExtraBtnClick && !data.dic_operating_room_id) {
                    this.$message.error(`请选择手术间！`)
                    throw new Error(`EndIterative`)
                }
                if (this.isEmergency == 1) {
                    data.enum_surgery_type = 1
                    data.is_emergency = 1
                }
                let obj = {
                    sequence: data.sequence,
                    apply_time: data.apply_time,
                    plan_time: data.plan_time,
                    cost_time: data.cost_time,
                    infectious: data.infectious && data.infectious.join(`,`),
                    is_fasting: data.is_fasting,
                    is_day_surgery: data.is_day_surgery,
                    is_endoscopy: data.is_endoscopy,
                    remark: data.remark,
                    enum_asa: data.enum_asa,
                    enum_surgery_scale: data.enum_surgery_scale,
                    enum_surgery_type: data.enum_surgery_type,
                    is_emergency: data.is_emergency,
                    dic_section_id: data.sectionobj && data.sectionobj.value,
                    dic_inpatient_section_id: data.inpatientobj && data.inpatientobj.value,
                    dic_operating_room_id: data.dic_operating_room_id,
                    dic_operating_room: data.dic_operating_room,
                    dic_operating_ward_id: data.dic_operating_ward_id,
                    enum_isolation_status: data.enum_isolation_status,
                    enum_cut_level: data.enum_cut_level,
                    iconValue: `el-icon-star-on`,
                    custom_status: data.custom_status,
                    visit_info: {
                        age: data.age,
                        height: data.height,
                        weight: data.weight,
                        bed_no: data.bed_no,
                        visit_no: data.visit_no,
                        outpatient_no: data.outpatient_no,
                        visit_time: data.visit_time,
                        phone: data.phone,
                        address: data.address,
                        enum_visit_type: data.enum_visit_type,
                        enum_pay_type: data.enum_pay_type,
                        name: data.name,
                        birthday: data.birthday,
                        card_type: data.card_type,
                        card_no: data.card_no,
                        insurance_no: data.insurance_no,
                        enum_blood_type: data.enum_blood_type,
                        enum_rh_blood_type: data.enum_rh_blood_type,
                        enum_sex: data.enum_sex,
                        his_id: data.his_id
                    },
                    plan_anaes_methods: data.plan_anaes_methods,
                    plan_diseases: data.plan_diseases && data.plan_diseases.map(d => d.value),
                    plan_surgeries: data.plan_surgeries && data.plan_surgeries.map(d => d.value),
                    plan_surgeon: data.plan_surgeon && data.plan_surgeon.value,
                    plan_surgeon_assistants: data.plan_surgeon_assistants && data.plan_surgeon_assistants.map(d => d.value),
                    plan_anes_doctor: data.plan_anes_doctor && data.plan_anes_doctor.value || `-1`,
                    plan_anes_assistants: data.plan_anes_assistants && data.plan_anes_assistants.map(d => d.value),
                    plan_circuit_nurse: data.plan_circuit_nurse && data.plan_circuit_nurse.map(d => d.value),
                    plan_equipment_nurse: data.plan_equipment_nurse && data.plan_equipment_nurse.map(d => d.value),
                    is_extra: data.isExtraBtnClick,
                    is_local_anes: data.is_local_anes,
                    enum_outoperatingroomtype: data.enum_outoperatingroomtype
                }
                // 新增的时候把动态列字段放到obj.extra_datas对象里面
                this.$surgeryInfoExtraParamUtil.SetSurgeryInfoExtraDatas(this.extendColumnList, obj, data)
                let req = this.myaxios.post(`/api/Preoperative/Apply/Post`, obj)
                req.then(res => {
                    this.visibleSync = false
                    that.$emit(`afteradd`, res)
                    resolve(res)
                }).catch(e => reject(e))
            })
        }
    }
}
</script>
<style scoped>
</style>
<style lang="less">
.title1 p {
    background: lightgray;
    font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Scheduling/AddSurgery.vue